/**
 * Operator catalog for IfClauseEditor — what inputs the UI renders per operator
 * and which operators make sense for each base-field type.
 */

export const OPERATORS = {
	const: { label: 'equals', widget: 'text', needsValue: true },
	enum: { label: 'is one of', widget: 'csv', needsValue: true },
	not_in: { label: 'is not in', widget: 'csv', needsValue: true },
	minimum: { label: '>=', widget: 'number', needsValue: true },
	maximum: { label: '<=', widget: 'number', needsValue: true },
	exclusive_minimum: { label: '>', widget: 'number', needsValue: true },
	exclusive_maximum: { label: '<', widget: 'number', needsValue: true },
	contains_const: { label: 'contains', widget: 'text', needsValue: true },
	type_is_null: { label: 'is null', widget: 'none', needsValue: false },
};

const STRING_LIKE = new Set(['string', 'date', 'date-time']);
const NUMERIC = new Set(['integer', 'number']);

export function getAvailableOperators(fieldType) {
	if (fieldType === 'array') return ['contains_const', 'type_is_null'];
	if (fieldType === 'boolean') return ['const', 'enum', 'type_is_null'];
	if (STRING_LIKE.has(fieldType)) return ['const', 'enum', 'not_in', 'type_is_null'];
	if (NUMERIC.has(fieldType)) {
		return ['const', 'enum', 'not_in',
			'minimum', 'maximum', 'exclusive_minimum', 'exclusive_maximum',
			'type_is_null'];
	}
	return ['const', 'enum', 'not_in', 'type_is_null'];
}

export const THEN_TYPES = [
	{ label: 'string', value: 'string' },
	{ label: 'integer', value: 'integer' },
	{ label: 'number', value: 'number' },
	{ label: 'boolean', value: 'boolean' },
	{ label: 'date', value: 'date' },
	{ label: 'date-time', value: 'date-time' },
	{ label: 'array', value: 'array' },
	{ label: 'null', value: 'null' },
];

export const ARRAY_ITEM_TYPES = [
	{ label: 'string', value: 'string' },
	{ label: 'integer', value: 'integer' },
	{ label: 'number', value: 'number' },
	{ label: 'boolean', value: 'boolean' },
];

export const FORMATS = [
	{ label: '(none)', value: '' },
	{ label: 'email', value: 'email' },
	{ label: 'uri', value: 'uri' },
	{ label: 'uuid', value: 'uuid' },
	{ label: 'date', value: 'date' },
	{ label: 'date-time', value: 'date-time' },
];
